import * as React from 'react'
import Social from '../Social'
import LogoImage from '../../images/logo/logo_desktop.svg'
import Analytics from '../../images/logo/analytics_text.svg'
import { useNavigate } from 'react-router'

export const ChartsAppBar = () => {
    const navigate = useNavigate()
    return (
        <div className='relative w-full flex flex-col flex-col-reverse lg:flex justify-center pt-[40px]'>
            {/* <div className='w-full  justify-between bg-transparent'> */}
            <div className='ml-4 lg:ml-0'>
                <div className='flex'>
                    <Social />
                </div>
            </div>
            <div className='ml-4 lg:ml-0 lg:absolute left-[50%] ml-2 lg:ml-0 flex-1 flex lg:flex-row items-center lg:translate-x-[-50%] mb-2 lg:mb-0'>
                <img onClick={() => navigate('/')} className='cursor-pointer mr-4 lg:w-[155px] lg:h-[38px] w-[130px]' src={LogoImage} />
                <img onClick={() => navigate('/')} className='cursor-pointer lg:w-[180px] lg:h-[34px] w-[160px]' src={Analytics} />
            </div>
            {/* <div className='flex-1' /> */}
            {/* </div> */}
        </div>
    )
}
